var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', _vm._b({
    attrs: {
      "content-class": "white",
      "z-index": "204",
      "offset-x": "",
      "right": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_vm._t("default", null, {
          "on": on
        })];
      }
    }], null, true)
  }, 'v-menu', _vm.$attrs, false), [_c('v-list', {
    staticStyle: {
      "height": "90svh"
    },
    attrs: {
      "dense": ""
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.uploadStatus
    }
  }), _c('sign-in-dialog', {
    ref: "sign-in",
    scopedSlots: _vm._u([{
      key: "subtitle",
      fn: function () {
        return [_vm._v("Please sign in to upload custom media")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "upload",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }), _c('dialog-scroll-lock', {
    attrs: {
      "width": "300",
      "persistent": "",
      "value": !!_vm.tryDelete
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("Are you sure?")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4 break-word"
  }, [_vm._v("Are you sure you want to delete this image?")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.tryDelete = null;
      }
    }
  }, [_vm._v("No")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.deleteTexture(_vm.tryDelete);
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._l(_vm.textures, function (texture, i) {
    return [texture ? _c('v-list-item', {
      staticClass: "pa-0",
      class: {
        'primary--text': texture.name == 'Add custom…'
      },
      attrs: {
        "disabled": _vm.deleting == texture.name || texture.name == 'Add custom…' && _vm.loadStatus.pending,
        "input-value": texture.name == 'Add custom…' ? false : _vm.value == texture.src
      },
      on: {
        "click": function () {
          return texture.name == 'Add custom…' ? _vm.promptUpload() : _vm.$emit('input', texture.src);
        }
      }
    }, [texture.name == 'Add custom…' ? [_vm.loadStatus.pending ? _c('v-progress-circular', {
      staticClass: "mx-3 my-1",
      attrs: {
        "size": "24",
        "indeterminate": ""
      }
    }) : _c('v-icon', {
      staticClass: "mx-3 my-1",
      attrs: {
        "color": "primary"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.mdiUpload)
      }
    })] : _c('v-card', {
      staticClass: "flex-shrink-0 mx-2",
      staticStyle: {
        "background-size": "cover"
      },
      style: {
        'background-image': texture.src ? `url('${texture.src}')` : null,
        'background-color': _vm.backgroundColor
      },
      attrs: {
        "outlined": "",
        "width": "32",
        "height": "32"
      }
    }), _c('v-list-item-title', {
      staticClass: "mx-3 d-flex align-center"
    }, [_c('div', {
      staticClass: "flex-grow-1 texture-name"
    }, [_vm._v(_vm._s(_vm.stripUUID(texture.name)))]), texture.custom ? _c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "icon": "",
        "color": "warning",
        "loading": _vm.deleting == texture.name
      },
      on: {
        "!click": function ($event) {
          $event.stopPropagation();
          _vm.tryDelete = texture;
        }
      }
    }, [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(_vm.mdiDelete)
      }
    })], 1) : _vm._e()], 1)], 2) : _c('v-divider', {
      staticClass: "my-2"
    })];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }